import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import SwapMainAPP from "./tables/SwapMainApp";


// 当go to "/" 的时候先验证local storage有没有email address 存过，有的话后台验证token是否有效
const GatewayTokenVerifier2 = () => {
  const navigate = useNavigate();
  const { verifyGatewayToken } = useAuth();
  const [shouldShowApp, setShouldShowApp] = useState(false);

  useEffect(() => {
    const gatewayToken = localStorage.getItem('gatewayToken');

    if (!gatewayToken) {
      // 如果没有 token，显示 SwapMainAPP
      setShouldShowApp(true);
      return;
    }

    // 如果存在 token，就验证
    (async () => {
      const isValid = await verifyGatewayToken(gatewayToken);
      if (isValid) {
        // 如果验证通过，则让用户直接跳转到 swap
        navigate(`/swap?token=${gatewayToken}`, { replace: true });
      } else {
        // 如果 token 无效，清除 token 并显示 SwapMainAPP
        localStorage.removeItem('gatewayToken');
        setShouldShowApp(true);
      }
    })();

  }, [navigate, verifyGatewayToken]);

  // 如果没有 token 或 token 无效且在本地开发，显示 SwapMainAPP
  if (shouldShowApp) {
    return <SwapMainAPP />;
  }

  // 显示加载状态，因为可能会重定向
  return null;
};

export default GatewayTokenVerifier2;